import { ApiOperationItems } from "~enums/apiOperationItems.ts";
import { useApiOperations } from "~hooks/useApiOperations.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { ensureDefaultOperationResponse, isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";
import { useExportFixturePlayByPlayFlaggedEvents } from "./useExportFixturePlayByPlayFlaggedEvents.ts";

export const useFixturePlayByPlayService = () => {
  const { mutateAsync: exportFixturePlayByPlayFlaggedEventsFn, isPending: isExportPending } = useExportFixturePlayByPlayFlaggedEvents();

  const { execute } = useApiOperations(ApiOperationItems.FIXTURE_PLAY_BY_PLAY);

  const exportFlaggedEvents = async (fieldNames: Array<string>): Promise<DefaultOperationSuccessResponse> =>
    ensureDefaultOperationResponse(
      await execute(() => exportFixturePlayByPlayFlaggedEventsFn(fieldNames), {
        successMessageId: "fixturePBPEvent.export.started",
        isSucceeded: isDefaultOperationSucceeded,
      }),
      "Fixture play-by-play export was not started",
    );

  return {
    exportFlaggedEvents,
    isExportPending,
  };
};
